// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file user_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { InviteUserRequestSchema, InviteUserResponseSchema, UserCreateSchema, UserListRequestSchema, UserListSchema, UserPasswordSetSchema, UserSchema, UserUpdateSchema } from "./user_pb";
import { file_user } from "./user_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file user_service.proto.
 */
export const file_user_service: GenFile = /*@__PURE__*/
  fileDesc("ChJ1c2VyX3NlcnZpY2UucHJvdG8SCXJhY2Nvb25haSJPCgtVc2VyUmVxdWVzdBIKCgJpZBgBIAIoBBI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYAiACKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZDKCAwoLVXNlclNlcnZpY2USNgoKQ3JlYXRlVXNlchIVLnJhY2Nvb25haS5Vc2VyQ3JlYXRlGg8ucmFjY29vbmFpLlVzZXIiABI0CgdHZXRVc2VyEhYucmFjY29vbmFpLlVzZXJSZXF1ZXN0Gg8ucmFjY29vbmFpLlVzZXIiABI2CgpVcGRhdGVVc2VyEhUucmFjY29vbmFpLlVzZXJVcGRhdGUaDy5yYWNjb29uYWkuVXNlciIAEj4KCUxpc3RVc2VycxIaLnJhY2Nvb25haS5Vc2VyTGlzdFJlcXVlc3QaEy5yYWNjb29uYWkuVXNlckxpc3QiABJLCgpJbnZpdGVVc2VyEhwucmFjY29vbmFpLkludml0ZVVzZXJSZXF1ZXN0Gh0ucmFjY29vbmFpLkludml0ZVVzZXJSZXNwb25zZSIAEkAKD1NldFVzZXJQYXNzd29yZBIaLnJhY2Nvb25haS5Vc2VyUGFzc3dvcmRTZXQaDy5yYWNjb29uYWkuVXNlciIAQgZaBC4vcGI", [file_user]);

/**
 * @generated from message raccoonai.UserRequest
 */
export type UserRequest = Message<"raccoonai.UserRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.UserRequest
 */
export type UserRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.UserRequest.
 * Use `create(UserRequestSchema)` to create a new message.
 */
export const UserRequestSchema: GenMessage<UserRequest, {jsonType: UserRequestJson}> = /*@__PURE__*/
  messageDesc(file_user_service, 0);

/**
 * @generated from service raccoonai.UserService
 */
export const UserService: GenService<{
  /**
   * @generated from rpc raccoonai.UserService.CreateUser
   */
  createUser: {
    methodKind: "unary";
    input: typeof UserCreateSchema;
    output: typeof UserSchema;
  },
  /**
   * @generated from rpc raccoonai.UserService.GetUser
   */
  getUser: {
    methodKind: "unary";
    input: typeof UserRequestSchema;
    output: typeof UserSchema;
  },
  /**
   * @generated from rpc raccoonai.UserService.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof UserUpdateSchema;
    output: typeof UserSchema;
  },
  /**
   * @generated from rpc raccoonai.UserService.ListUsers
   */
  listUsers: {
    methodKind: "unary";
    input: typeof UserListRequestSchema;
    output: typeof UserListSchema;
  },
  /**
   * @generated from rpc raccoonai.UserService.InviteUser
   */
  inviteUser: {
    methodKind: "unary";
    input: typeof InviteUserRequestSchema;
    output: typeof InviteUserResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.UserService.SetUserPassword
   */
  setUserPassword: {
    methodKind: "unary";
    input: typeof UserPasswordSetSchema;
    output: typeof UserSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_user_service, 0);

